module.exports = __webpack_public_path__ + "static/media/sports.333e4ba1.jpg";